

// 画面下の固定バーから、ページ内のカート追加ボタンを押す。
//
// theme.js はバリエーションが在庫切れになると data-action="add-to-cart" を外し、
// ボタンの文言を「再入荷通知を受け取る」に書き換える。
// data-action だけを頼りに探すと、その状態で querySelector が null を返して
// TypeError で無反応になるため、クラスで探してフォールバックする。
function getThemeCartButton() {
  return (
    document.querySelector('[type="submit"][data-action="add-to-cart"]') ||
    document.querySelector('.ProductForm__AddToCart')
  );
}

function clickThemeCartButton() {
  const button = getThemeCartButton();
  if (!button) return;
  button.click();
}

// 2024.7.29 Add [select-art]テンプレートの対応
function clickArtPopupCartButton(e,_popupId,_variantId) {
  const targetBtn = document.querySelector(`#${_popupId} [data-variant-id="${_variantId}"]`);

  if(targetBtn){
    e.preventDefault();
    targetBtn.click();
  }
}

// // ポップアップを開く関数
// - targetId : 開くポップアップのID
function openCustomVariantPopup(targetId) {
  document.body.classList.add('is-product-popup-open');
  document.getElementById(targetId).classList.add('open');
}

// 2024.7.29 Add [select-art]テンプレートの対応
//  閉じる関数を統合
// - targetId : 閉じるポップアップのID
function closePopupOnOverlayClick(eventOrTargetId, targetId) {
  // event + targetId（オーバーレイからの呼び出し）: オーバーレイ自身のクリックのみ閉じる
  if (eventOrTargetId instanceof Event) {
    if (eventOrTargetId.target !== eventOrTargetId.currentTarget) return;
    targetId = targetId; // 第2引数をそのまま使用
  } else {
    // targetIdのみ（閉じるボタンからの呼び出し）: 常に閉じる
    targetId = eventOrTargetId;
  }
  document.body.classList.remove('is-product-popup-open');
  document.getElementById(targetId).classList.remove('open');
}

// // // ポップアップを閉じる関数
// function closePopupOnOverlayClick(event) {
//   if (event.target.id === 'c-variantPopup') {
//     document.getElementById('c-variantPopup').classList.remove('open');
//     document.body.classList.remove('is-product-popup-open');
//   }
// }

// // // ポップアップの外側をクリックして閉じる
// const closeVariantPopup =  document.getElementById('c-closeVariantPopup');
// if(closeVariantPopup){
//   closeVariantPopup.onclick = function() {
//     document.body.classList.remove('is-product-popup-open');
//     document.getElementById('c-variantPopup').classList.remove('open');
//   }
// }

document.addEventListener("DOMContentLoaded", function () {
  // ボタンを表示・非表示するための変数
  var variantBtnWrapper = document.querySelector(".c-variant-btn-wrapper");
  var buyButtons = document.querySelector(".ProductForm__BuyButtons");

  if (!variantBtnWrapper || !buyButtons) return;

  // スクロール時にボタンの表示・非表示を切り替える
  window.addEventListener("scroll", function () {
    var windowHeight = window.innerHeight;
    var buyButtonsPosition = buyButtons.getBoundingClientRect().bottom;
    if (buyButtonsPosition < windowHeight) {
      variantBtnWrapper.classList.add("show");
    } else {
      variantBtnWrapper.classList.remove("show");
    }
  });

  // 固定バーのボタンをページ内のカート追加ボタンに追従させる。
  //
  // 固定バーはLiquidで初期表示時に1度だけ描画されるため、そのままだと
  // バリエーションを切り替えても文言と挙動が初期状態のまま固定される。
  // (売り切れを選んでも「カートに追加」のまま無反応、?variant= で売り切れを
  //  開くと在庫ありに戻しても「再入荷通知」のまま、など)
  // theme.js が書き換えるページ内ボタンの状態をそのまま写して解消する。
  var followButton = variantBtnWrapper.querySelector("[data-openVariantPopup]");
  var themeCartButton = document.querySelector(".ProductForm__BuyButtons .ProductForm__AddToCart");

  // アートオプション商品は対象外。
  // 固定バーのアートボタンは onclick が3種類(openCustomVariantPopup /
  // clickArtPopupCartButton / callBackInStock)あるため onclick では判別できない。
  // アート版はボタンに .variant-button--art が付くので、それで判定する。
  // またアート商品にはページ内の標準カートボタンが無く、フォールバックで
  // ポップアップ内の .ProductForm__AddToCart を掴んでしまうため必ず除外する。
  if (!followButton || !themeCartButton) return;
  if (followButton.classList.contains("variant-button--art")) return;
  if (variantBtnWrapper.querySelector(".variant-button--art")) return;

  var syncFollowButton = function () {
    // ページ内の標準カートボタンに限定する。
    // ポップアップ内のボタンを掴むと別商品の状態を写してしまう。
    var source = document.querySelector(".ProductForm__BuyButtons .ProductForm__AddToCart");
    if (!source) return;

    var label = followButton.querySelector("span") || followButton;
    label.textContent = (source.textContent || "").trim();
    followButton.disabled = source.disabled;

    // 見た目もページ内ボタンに合わせる。
    // Liquidが初期描画時に付けた配色(再入荷通知用の Button--secondary と
    // inline の color:#fff)が残ると、在庫ありに戻しても配色が食い違い、
    // disabled時は薄い背景に白文字で読めなくなる。
    //
    // Button--primary は付けない。固定バーは .variant-button でブランド色を
    // 持っており、.c-Button.Button--primary が白背景で上書きしてしまうため。
    followButton.classList.toggle("Button--secondary", source.classList.contains("Button--secondary"));
    followButton.style.removeProperty("color");

    // ページ内ボタンをそのまま押すので、固定バー側で分岐を持たない
    followButton.setAttribute("onclick", "clickThemeCartButton()");
  };

  syncFollowButton();

  new MutationObserver(syncFollowButton).observe(themeCartButton, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
  });
});
